import { createAction, props } from "@ngrx/store";
import { TfnModel } from "./state";

export const ResetDataSavedAction = createAction('[Tfn Form] reset data saved property');

export const SaveTfnRequestAction = createAction('[Tfn Form] save page tfn',
    props<{ step: number, field: string, data: TfnModel }>());

export const SaveTfnResponseAction = createAction('[Tfn Form] update next page response');